import { FilterHandler } from '@btime/react-contexts'
import React from 'react'

import { PermissionChecker } from '../../session'
import ControlledModal from '../../../components/modals/ControlledModal'
import FolderTable from './folders/FolderTable'
import FoldersLoader from './folders/_load/FoldersLoader'
import Header from './Header'
import Separator from '../../../components/helpers/Separator'

const TriggersModal = props => {
  return (
    <ControlledModal width="76rem" {...props}>
      <PermissionChecker permission="listTrigger">
        <Header />
        <Separator weight={6} />
        <FilterHandler>
          <FoldersLoader>
            <FolderTable />
          </FoldersLoader>
          <Separator weight={4} />
        </FilterHandler>
      </PermissionChecker>
    </ControlledModal>
  )
}

export default TriggersModal
